if (!customElements.get('ct-product-tabs')) {
  customElements.define(
    'ct-product-tabs',
    class CtProductTabs extends HTMLElement {
      constructor() {
        super();
        this.handleClick = this.handleClick.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.handleDocumentClick = this.handleDocumentClick.bind(this);
        this.handleBoxRowToggle = this.handleBoxRowToggle.bind(this);
      }

      connectedCallback() {
        this.triggers = Array.from(this.querySelectorAll('[data-tab-trigger]'));
        this.panels = Array.from(this.querySelectorAll('[data-tab-panel]'));
        this.boxRows = Array.from(this.querySelectorAll('.ct-product-tabs__box-row'));

        if (this.triggers.length && this.panels.length) {
          this.addEventListener('click', this.handleClick);

          this.triggers.forEach((trigger) => {
            trigger.addEventListener('keydown', this.handleKeydown);
          });

          const defaultTab = this.dataset.defaultTab || this.triggers[0]?.dataset.tabTrigger;
          this.activateTab(defaultTab, false);
        }

        if (this.boxRows.length) {
          this.boxRows.forEach((row) => {
            row.addEventListener('toggle', this.handleBoxRowToggle);
          });
        }

        document.addEventListener('click', this.handleDocumentClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);

        this.triggers?.forEach((trigger) => {
          trigger.removeEventListener('keydown', this.handleKeydown);
        });

        this.boxRows?.forEach((row) => {
          row.removeEventListener('toggle', this.handleBoxRowToggle);
        });

        document.removeEventListener('click', this.handleDocumentClick);
      }

      handleClick(event) {
        const trigger = event.target.closest('[data-tab-trigger]');
        if (!trigger || !this.contains(trigger)) return;

        this.activateTab(trigger.dataset.tabTrigger, true);
      }

      handleKeydown(event) {
        const currentTrigger = event.currentTarget;
        const currentIndex = this.triggers.indexOf(currentTrigger);

        if (currentIndex === -1) return;

        let nextIndex = null;

        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          nextIndex = (currentIndex + 1) % this.triggers.length;
        }

        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          nextIndex = (currentIndex - 1 + this.triggers.length) % this.triggers.length;
        }

        if (event.key === 'Home') {
          nextIndex = 0;
        }

        if (event.key === 'End') {
          nextIndex = this.triggers.length - 1;
        }

        if (nextIndex === null) return;

        event.preventDefault();
        const nextTrigger = this.triggers[nextIndex];
        this.activateTab(nextTrigger.dataset.tabTrigger, true);
      }

      handleDocumentClick(event) {
        if (!this.boxRows?.length) return;

        if (!this.contains(event.target)) {
          this.closeAllBoxRows();
          return;
        }

        const clickedBoxRow = event.target.closest('.ct-product-tabs__box-row');
        if (!clickedBoxRow) {
          this.closeAllBoxRows();
        }
      }

      handleBoxRowToggle(event) {
        const openedRow = event.currentTarget;
        if (!openedRow.open) return;

        this.boxRows.forEach((row) => {
          if (row !== openedRow) {
            row.removeAttribute('open');
          }
        });
      }

      closeAllBoxRows() {
        if (!this.boxRows?.length) return;

        this.boxRows.forEach((row) => {
          row.removeAttribute('open');
        });
      }

      activateTab(tabName, moveFocus = false) {
        if (!tabName) return;

        this.triggers.forEach((trigger) => {
          const isActive = trigger.dataset.tabTrigger === tabName;

          trigger.classList.toggle('is-active', isActive);
          trigger.setAttribute('aria-selected', isActive ? 'true' : 'false');
          trigger.setAttribute('tabindex', isActive ? '0' : '-1');

          if (isActive && moveFocus) {
            trigger.focus();
          }
        });

        this.panels.forEach((panel) => {
          const isActive = panel.dataset.tabPanel === tabName;
          panel.hidden = !isActive;
        });

        this.closeAllBoxRows();
      }
    }
  );
}